<template>
    <div id="cooperate" class="cooperate">
        <img :src="list.logo" alt="" class="banner-img" ondragstart="return false;" oncontextmenu="return false;">
        <div class="banner">
            <div class="banner-description">
            <div class="name">{{list.title1}}</div>
             <div class="description">{{list.title1s}}</div>
             <div class="btn" @click="openRs">立即联系</div>
           </div>
        </div>
           <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup"></i>
                <h1>{{list.title1}}</h1>
                <h3>{{list.title1s}}</h3>
                    <div class="endowloadDetail-description-btn flex align-cen">
                    <div class="open" @click="openRs">立即联系</div>
                </div>
            </div>
        </div>
             <div class="endowloadDetail-contaniner" >
                   <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen">
                    <div class="nav-text" 
                    :class="{ active: currentNav == -1 }"
                    @click="gethisList('',-1,'pageSize')"
                    >全部</div>
                <div class="nav-text"
                 v-for="(item,index) in classfy"
                :key="index"
                :class="{ active: currentNav == index }"
                 @click="gethisList(item.id,index,'pageSize')"
                >{{item.name}}</div>
                </div>
                </div>
          </div>
              <div class="card-container" v-if="platformAppContentList.length">
                <div class="containers">
                    <div class="list">
                        <div class="itemList flex align-cen"
                          v-for="(item,index) in platformAppContentList"
                            :key="item.id"
                            @click="openDetail(item)"
                        >
                            <div class="img">
                                 <img :src="item.pic || require('../../../assets/images/defuletNews.jpg')" alt="">
                            </div>
                            <div class="imgInfo">
                                <div class="title">{{item.name}}</div>
                                <!-- <p class="dateTit"> <span class="el-icon-date"></span>  <span class="data">{{item.createTime}}</span> </p> -->
                                <p class="newInfo newInfoimg" v-html="item.content"></p>
                                <p class="infoClick"><span class="detail">查看详情+</span></p>
                            </div>
                        </div>
                    </div>
                     <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                </div>
          </div>
            <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div>
         </div>
           <div class="apps-show logo-box" style="padding-top:0">
                 <div class="title">
                    {{list.title3}}
                </div>
                <div class="hz-logo flex align-cen">
                    <div class="hz-img"
                      v-for="(item, index) in list.moreImg"
                      :key="index"
                    >
                    <img :src="item.url" alt="">
                    </div>
                </div>
              </div>
        <goTop></goTop>
    </div>
</template>
<script>
import {softList,caseClassify,casePageList,accountClue} from "@/api/enterprise/index" // 配置详情、案例分类列表、分类列表
import debounce from '../../../utils/debounce.js' //防抖
import goTop from '@/components/goTop'
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import LocaStorage from "../../../utils/localstorage.js"
export default {
    name:'cooperate',

     components:{
        goTop,
        paginaTion
    },
    data () {
        return {
            clcikStatu:false,
          currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            classfy:[],
            platformAppContentList:[],
            list:{
                logo:'',
                title1:'',
                title1s:'',
            },
             tabPosition:'top',
            isFixed: false,
            isClick:false,
            contentTopList:[],
             currentNav:-1,
             fristId:'',
                list:{
                      moreTimg:[],
                      moreImg:[],
                      title1:'',
                      title2:'',
                      title3:'',
                      title4:'',
                      pic1:'',
                      pic2:'',
                      pic3:'',
                      pic4:'',
                      serveText1:'',
                      serveText2:'',
                      serveText3:'',
                      serveText4:'',
                      serveBotText1:'',
                      serveBotText2:'',
                      serveBotText3:'',
                      serveBotText4:''

            }
        }
    },
     mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
  },
    created () {
      let that = this
       document.title = "合作客户"
         if(this.$route.query.IsService == 1){
            this.openRs(1)
        }
        this.getDetail()
        this.getDetail1()
           //    异步同步执行
            this.getClassfy().then(function(){
            that.gethisList(that.fristId,-1)
            })
    },
    methods: {
          // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList(this.fristId,this.currentNav)
      },
      // 打开注册
      openRs(){
             if(LocaStorage.setAge().get('token1')){
               if(this.clcikStatu){
                     this.$util.Notifi('请勿重新申请！','error','fa-exclamation-circle');
                }else{
             accountClue({
                clueType:'合作客户',
                officialType:2
                },'enterprise')
                .then(res =>{
                    if(res.code == 0){
                        this.$util.Notifi('已收到您的消息，请等待工作人员联系您','success','fa-check'); 
                        this.clcikStatu = true
                          if(data){
                            this.$router.replace({ name: 'Hlyhcooperate', query: {} })
                            }
                    }else{
                         this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                })
                }
               
                
             }else{
                         const newurl = this.$router.resolve({name:'enHlyhLogin',  query:{clueType:'合作客户',redirectUrl:'Hlyhcooperate'}})
          window.open(newurl.href,'_blank')
             }
      },
         handleScroll(){
            var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
         var offsetTop = document.querySelector('.banner').offsetHeight
         // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
        },
         // 打开详情
             // 打开详情
        openDetail(data){
            console.log(data)
            if(data.contentType == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
              const newurl = this.$router.resolve({name: 'enCaseHlyhDetail', query: {id: data.id}})
        window.open(newurl.href,'_blank')
             }
            
        },
        // openDetail(id){
        //      const newurl = this.$router.resolve({name: 'enCaseHlyhDetail', query: {id: id}})
        // window.open(newurl.href,'_blank')
        // },
    // 获取详情
          getDetail(){
              softList({id:2},'enterprise')
                .then(res => {
                 res.data.forEach(item =>{

                     if(item.attributeName == "logo")   this.list.logo  = item.attributeValue
                    if(item.attributeName == "title1")  this.list.title1  = item.attributeValue
                    if(item.attributeName == "title1s") this.list.title1s  = item.attributeValue
                 })
                })
                .catch(err => {                  
                })
        },
              getDetail1(){
            this.platformAppContentList = []
              softList({id:1},'enterprise')
                .then(res => {
                 // 合作伙伴赋值
                let moreImgData = res.data.filter(item => !item.attributeName.indexOf("moreImg"))       
                     for (const key in moreImgData) {
                this.list.moreImg.push(
                      {
                    url:moreImgData[key].attributeValue,
                    id:moreImgData[key].id,
                  }
                   )
                  }
                })
                .catch(err => {                  
                })
        },
        // 案例分类
         async getClassfy(){
            await caseClassify({officialType:2},'enterprise')
            .then(res =>{
                this.classfy = res.data
            })
            .catch(err =>{})
        },
          // 获取新闻列表
        gethisList(id,index,page){
            this.fristId = id
            this.currentNav = index
            if(page){
                this.PageSize = 10
                this.currentPage = 1
            }
            casePageList({
                id:id,
                size:this.PageSize,
                current:this.currentPage,
                officialType:2
            },'enterprise')
            .then(res =>{
                console.log(res)
                this.platformAppContentList = res.data.records
                this.totalCount = res.data.total
            })
        },
    },
       destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style lang="scss" scoped>
.cooperate{
  position: relative;
     .item-gradient{
        display: none;
    }
    .banner-img{
            width: 100%;
            height: 396px;
            object-fit: cover;
        }
    .banner{
        position: absolute;
        top:0px;
        width: 100%;
        height: 396px;
           .banner-description{
            position: absolute;
            left: 15%;
            top: 35%;
            color: #fff;
            .name{
                color: #171717;
                font-size: 40px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #171717;
                line-height: 50px;
            }
            .description{
                font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #171717;
            line-height: 50px;
            }
                .btn{
                       width: 138px;
              cursor: pointer;
              border: none;
              height: 42px;
              line-height: 42px;
              font-size: 16px;
              text-align: center;
              vertical-align: middle;
              background-color: #2893f1;
              border-radius: 1px;
              margin-right: 20px;
              padding: 0px 0;
              color: #fff;
              margin-top: 20px;
                }
                //  .btn:hover{
                //     background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                //     font-weight: 700;
                //     box-shadow: none;
                //     color: #FFFFFF;
                //     a{
                //        color: #FFFFFF; 
                //     }
                //  }
    }
    }
         .fixed{
         position: fixed;
        top: 0px;
        left: 0;
        right: 0;
        z-index: 10;

      }
          .card-container{
        width: 100%;
        margin: 0 auto;
        padding-bottom: 62px;
        margin-top: 20px;
        .containers{
            max-width: 1540px;
            padding: 0 15px;
            margin: 0 auto;
            .list{
                .itemList{
                 border-bottom: 1px solid #EEEEEE;
                 padding: 36px 0;
                 .img{
                    width: 20%;
                    vertical-align: middle;
                    img{
                           object-fit: cover;
                            width: 100%;
                            max-height: 196px;
                    }
                 }
                 .imgInfo{
                    width: 75%;
                    vertical-align: middle;
                    padding-left: 56px;
                    cursor: pointer;
                    .title{
                    font-size: 20px;
                    color: #333333;
                    max-width: 650px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    }
                    p{
                        cursor: pointer;
                    }
                    .dateTit{
                        padding: 19px 0;
                        span{
                            color: #666;
                        }
                        .data{
                            font-size: 14px;
                            font-weight: 500;
                            line-height: 30px;
                            padding-left: 10px;
                        }
                    }
                    .newInfo{
                        font-size: 14px;
                        font-weight: 500;
                        color: #999999;
                        line-height: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .infoClick{
                        padding-top: 24px;
                        span{
                            font-size: 16px;
                            font-weight: 500;
                            color: #666666;
                            line-height: 24px;

                        }
                    }
                 }
                }
                .itemList:hover{
                        background: #F6F6F6;
                        .imgInfo{
                            .title{
                                color: #2893f1;
                            }
                            .infoClick{
                                span{color: #2893f1;}
                            }
                        }
                }
            }
        }
    }
      .logo-box{
     background: #f4f5f7;
     .title{
        padding-top: 40px;
     }
    }
    .apps-show{
          width: 100vw;
            margin: 0 auto;
            padding-top: 40px;
            text-align: center;
            .title{
                color: #181818;
                text-align: center;
                line-height: 48px;
                font-size: 28px;
                padding-bottom: 20px;
            }
                    .hz-logo{
                max-width: 1540px;
                 padding: 25px 15px 60px;
                flex-wrap: wrap;
                margin: 0 auto;
                .hz-img{
                        padding: 0;
                     flex: 0 0 18%;
                    margin-right: 20px;
                    margin-bottom: 20px;
                    img{
                     display: initial!important;
                    vertical-align: middle;
                    padding: 0 30px;
                    height: 90px;
                    width: 100%;
                    max-width: 264px;
                    }
                }
            }
    }
}
@media screen and (max-width: 1600px){
    .containers{
        max-width: 1200px !important;
        margin: auto;
    }
     .hz-logo{
            max-width: 1200px !important;
            margin: auto;
     } 
}
@media (max-width: 640px){
  #cooperate{
                       .hz-logo{
            width: 100%;
            padding: 0;
            .hz-img{
             flex: 0 0 30%; 
             margin-right: 9px;
            margin-bottom: 9px;
            img{
                padding: 0 10px;
                max-width: 100%;
            }
            }   
        }
     .apps-show{
            .title{
                font-size: 20px;
                line-height: 28px;
            }
            }
  }
     .banner{display: none;}

        .banner-img{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
       .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
       }
    }
}
::v-deep{
   .newInfoimg{
        *{
            font-size: 14px;
            color: #999 !important;
        }
        .ql-align-center{
            text-align: left;
        }
         p{
                         img{display: none !important;}
                       }
    }
  @media (max-width: 640px){
    .el-pagination__jump{
      margin-left: 0 !important;
    }
  }
    .nr{
            p{
                img{margin: 0 auto !important;
                display: block;
                }
            }
        }
              .jiange {
        margin-top: 62px !important;
        text-align: center;
    }
}
@media (max-width: 640px){
     .banner{display: none;}
        .banner-img{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
       .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
         .endowloadDetail-description-btn{
            justify-content: space-evenly;;
                div{
                     min-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 15px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 10px;
                   margin-top: 10px;
                    padding: 5px 0;
                    a{
                        color: #000;
                    }
                }
              
                 div:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #fff;
                    
                 }
            }
       }
    }
}
@media (max-width: 640px){
#cooperate{
  .banner-img{
    height: auto;
  }
}
}
</style>